/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Payment_MethodInputs */

const en_plan_payment_method = /** @type {(inputs: Plan_Payment_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment Method`)
};

const es_plan_payment_method = /** @type {(inputs: Plan_Payment_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Método de pago`)
};

/**
* | output |
* | --- |
* | "Payment Method" |
*
* @param {Plan_Payment_MethodInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_payment_method = /** @type {((inputs?: Plan_Payment_MethodInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Payment_MethodInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_payment_method(inputs)
	return en_plan_payment_method(inputs)
});